import { Clock, Mail, Phone, MessageCircle } from 'lucide-react';
import { Modal, Button, ContactLink, Card } from '../ui';
import { companyInfo, locations } from '../../data';

export interface ContactModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export function ContactModal({ isOpen, onClose }: ContactModalProps) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Contact" size="lg">
            <div className="space-y-6">
                {/* Email Section */}
                <div>
                    <h4 className="font-font-s font-semibold text-text-color mb-3 flex items-center gap-2">
                        <Mail className="w-5 h-5 text-main-color" />
                        Email
                    </h4>
                    <div className="flex flex-wrap gap-3">
                        {companyInfo.contact.emails.map((email) => (
                            <ContactLink key={email} type="email" value={email} showIcon={false} className="text-base" />
                        ))}
                    </div>
                </div>

                {/* Working Hours */}
                <Card variant="outlined" padding="sm" className="bg-blue-50 border-blue-100">
                    <div className="flex items-start gap-3">
                        <Clock className="w-5 h-5 text-main-color flex-shrink-0 mt-0.5" />
                        <div>
                            <h4 className="font-font-s font-semibold text-text-color mb-1">Program de lucru</h4>
                            <p className="text-gray-600 font-font-s text-sm">
                                {companyInfo.contact.workingHours.days}: {companyInfo.contact.workingHours.hours}
                            </p>
                        </div>
                    </div>
                </Card>

                {/* Phone Section */}
                <div>
                    <h4 className="font-font-s font-semibold text-text-color mb-3 flex items-center gap-2">
                        <Phone className="w-5 h-5 text-main-color" />
                        Telefon / WhatsApp (urgente)
                    </h4>
                    <div className="flex flex-wrap gap-4">
                        {companyInfo.contact.phones.map((phone) => (
                            <div key={phone} className="flex items-center gap-3">
                                <ContactLink type="phone" value={phone} />
                                <span className="text-gray-400">|</span>
                                <ContactLink type="whatsapp" value={phone} label="WhatsApp" />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Locations */}
                <div>
                    <h4 className="font-font-s font-semibold text-text-color mb-3">Locatii</h4>
                    <div className="grid md:grid-cols-2 gap-4">
                        {locations.map((location) => (
                            <Card key={location.id} variant="outlined" padding="sm">
                                <p className="font-font-s font-semibold text-text-color mb-1">{location.name}</p>
                                <p className="text-gray-600 font-font-s text-sm mb-2">{location.address}</p>
                                <p className="text-gray-500 font-font-s text-xs italic">({location.landmark})</p>
                            </Card>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mt-6 flex justify-end">
                <Button onClick={onClose} variant="primary">
                    Inchide
                </Button>
            </div>
        </Modal>
    );
}
